module.exports = __webpack_public_path__ + "img/icon381.3f1dc956.png";